<template>
  <div class="home-page">
    <Jumbotron />
    <section class="section -bg-top-04 -what-we-offer-bg">
      <div class="container">
        <WhatWeOffer />
      </div>
    </section>
    <section class="section has-background-white-bis">
      <div class="container">
        <TryItOut />
      </div>
    </section>
  </div>
</template>

<script>
import Jumbotron from "@/components/library/Jumbotron.vue";
import WhatWeOffer from "@/components/library/WhatWeOffer.vue";
import TryItOut from "@/components/library/TryItOut.vue";

export default {
  name: "homePage",
  components: {
    Jumbotron,
    WhatWeOffer,
    TryItOut
  }
};
</script>

<style scoped lang="scss">
.-what-we-offer-bg {
  background-position: 50% 03%;
  background-repeat: none;
  background-size: cover;
}
</style>
